<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
              <v-layout row wrap>
                 <v-flex d-flex xs12 style="margin-top: 20px">
                  <v-layout column>
                    <v-flex d-flex>
                      <v-card style="">
                        <v-card-text>
                          <h3 style="text-align: left;margin-bottom: 10px">All Trucks</h3>
                          <v-btn flat class="primary" style="margin-left:900px;margin-bottom: 10px;margin-top:-40px" v-on:click="back()">Back</v-btn>
                          <v-divider divider: true></v-divider>
                          <v-layout row wrap>
                            <v-flex xs3 child-flex>
                              <v-layout row wrap>
                                <label style="margin-top:20px;margin-right: 10px">Show</label>
                                <v-overflow-btn
                                  :items="dropdown_list"
                                  label=""
                                  target="#dropdown-example"
                                ></v-overflow-btn>
                                <label style="margin-top:20px;margin-left: 10px">Entries</label>
                              </v-layout>
                            </v-flex>
                            <v-flex xs3 child-flex></v-flex>
                            <v-flex xs6 child-flex>
                              <v-layout row wrap>
                                <v-text-field
                                  label="Search"
                                ></v-text-field>
                                <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                                <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>list</v-icon></v-btn>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                          <v-data-table
                            :headers="headers"
                            :items="desserts"
                            class="elevation-1"
                            style="width:1200px"
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.no}}</td>
                              <td class="text-xs-left">{{ props.item.workservicelocation }}</td>
                              <td class="text-xs-left">{{ props.item.vehicleno }}</td>
                              <td class="text-xs-left">{{ props.item.transportationtype }}</td>
                              <td class="text-xs-left">{{ props.item.vehicleprovider }}</td>
                              <td class="text-xs-left">{{ props.item.thirdparty }}</td>
                              <td class="text-xs-left">{{ props.item.currentstatus }}</td>
                              <td class="text-xs-left">{{ props.item.vehicledetails }}</td>
                              <td class="text-xs-left"><v-btn flat style="color:green">Ready To Transport</v-btn></td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Work Service Location', value: 'workservicelocation' },
        { text: 'Vehicle No', value: 'vehicleno' },
        { text: 'Transportation Type', value: 'transportationtype' },
        { text: 'Vehicle Provider', value: 'vehicleprovider' },
        { text: 'Third Party Carriers (Contracted)- Career Name', value: 'thirdparty' },
        { text: 'Current Status', value: 'currentstatus' },
        { text: 'Vehicle Details', value: 'vehicledetails' },
        { text: 'Ready To Transport', value: '' }
      ],
      desserts: [
        {
          no: '1',
          workservicelocation: 'Mumbai',
          vehicleno: 'MH-12-FB-6789',
          transportationtype: 'Out-bound',
          vehicleprovider: 'Third Party Carrier',
          thirdparty: 'OM Logistics',
          currentstatus: 'Free(Ready To Transport)',
          vehicledetails: 'Flat Bed Truck'
        },
        {
          no: '2',
          workservicelocation: 'Mumbai',
          vehicleno: 'MH-12-JR-5896',
          transportationtype: 'In-bound',
          vehicleprovider: 'Third Party Carrier',
          thirdparty: 'Gati Logistics',
          currentstatus: 'Free(Ready To Transport)',
          vehicledetails: 'Bharat Heavy Vehicle'
        },
        {
          no: '3',
          workservicelocation: 'Mumbai',
          vehicleno: 'MH-12-KJ-2563',
          transportationtype: 'In-bound',
          vehicleprovider: 'Owned By Company',
          thirdparty: '',
          currentstatus: 'Free(Ready To Transport)',
          vehicledetails: 'Tata Metadoor 407'
        }
      ]
    }
  },
  methods: {
    back () {
      this.$router.push('/Truckingaddnewtruck')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Truckingalltrucksreport.vue